import {AuthService} from '../services/auth.service';
import {Component, OnInit} from '@angular/core';

import AgreementsConfig from '../table/configs/agreements.json';

@Component({
  templateUrl: './agreements.component.html'
})
export class AgreementsComponent implements OnInit {
  private user: any;
  public agreementsConfig: any;
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;

  constructor(private authService: AuthService) {
    this.agreementsConfig = AgreementsConfig;
    this.showBasicInfo = false;
  }

  public async ngOnInit(): Promise<any> {
    await this.initUser();
    await this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      subtitle: [],
      title: 'Συμφωνίες'
    };
  }

  private async initUser() {
    this.user = await this.authService.getUser();
    await this.initBasicInfo();
  }

}
